"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateAddress = generateAddress;
exports.parseAddress = parseAddress;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * @param addressString
 * @returns {Promise<object>}
 */
function parseAddress(addressString) {
  var parsed = addressString.split(',');
  var data = {};
  if (parsed[0].includes('Unit')) {
    var unit = parsed[0].split(' ');
    data = {
      suite: unit[1],
      firstLine: parsed[1],
      city: parsed[2],
      province: parsed[3],
      postalCode: parsed[4] ? parsed[4].toUpperCase() : ''
    };
  } else {
    data = {
      suite: '',
      firstLine: parsed[0],
      city: parsed[1],
      province: parsed[2],
      postalCode: parsed[3] ? parsed[3].toUpperCase() : ''
    };
  }
  return data;
}

/**
 * @param addressObj
 * @returns {Promise<string|null>}
 */
function generateAddress(addressObj) {
  if (_typeof(addressObj) === 'object') {
    var _address = "";
    var addressArr = addressObj.firstLine.split(" ");
    if (addressArr[0].includes('-')) {
      var unitNumberArr = addressArr[0].split("-");
      var suite = unitNumberArr[0];
      var streetNumber = unitNumberArr[1];
      addressArr.shift();
      addressObj.suite = suite;
      addressObj.firstLine = "".concat(streetNumber, " ").concat(addressArr.join(' '));
    }
    if (addressObj.postalCode.indexOf(' ') !== 3) {
      var start = addressObj.postalCode.substring(0, 3);
      var end = addressObj.postalCode.substring(3, 6);
      addressObj.postalCode = "".concat(start, " ").concat(end);
    }
    addressObj.postalCode = addressObj.postalCode.toUpperCase();
    _address = addressObj.suite ? "Unit ".concat(addressObj.suite.trim(), ",").concat(addressObj.firstLine.trim(), ",").concat(addressObj.city.trim(), ",").concat(addressObj.province.trim(), ",").concat(addressObj.postalCode.trim(), ",Canada") : "".concat(addressObj.firstLine.trim(), ",").concat(addressObj.city.trim(), ",").concat(addressObj.province.trim(), ",").concat(addressObj.postalCode.trim(), ",Canada");
    return _address;
  }
  var address = addressObj;
  return address;
}